var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-text-field', _vm._b({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+1 (###) ###-####',
      expression: "'+1 (###) ###-####'"
    }],
    attrs: {
      "type": "tel",
      "rules": (_vm.rules || []).map(function (x) {
        return function (v) {
          return x(_vm.parsePhone(v));
        };
      })
    },
    on: {
      "input": function (x) {
        return _vm.$emit('input', _vm.parsePhone(x));
      },
      "paste": _vm.onPastePhone
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('country-flag', {
          staticClass: "my-n1",
          staticStyle: {
            "transform": "scale(.8)"
          },
          attrs: {
            "country": "us"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formattedPhone,
      callback: function ($$v) {
        _vm.formattedPhone = $$v;
      },
      expression: "formattedPhone"
    }
  }, 'v-text-field', _vm.$attrs, false), [_vm._l(_vm.$slots, function (_, name) {
    return _vm._t(name, null, {
      "slot": name
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }